import { render } from "./OpenTsvFileModal.vue?vue&type=template&id=e7ff9a7a"
import script from "./OpenTsvFileModal.vue?vue&type=script&lang=js"
export * from "./OpenTsvFileModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__